import { LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LabelColumnV2 } from "../../components/DataGridV2/DataColumnsV2";

export const getAddRepairRequestProjectColumns = ({ 
    t,
    keyPrefix,
    i18n,
    apiRef,
}) => {
    const getOptions = getGridContextMenuList({
        filterKey: LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_PROJECTS_COLUMN_FILTER[keyPrefix],
        sortKey: LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_PROJECTS_COLUMN_SORT[keyPrefix],
        i18n,
        t,
        apiRef,
        mode: "client",
    })

    return [
        {
            download: true,
            print: true,
            field: "projectName",
            headerName: t("general.projectName"),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.projectName}
                        cellSubMenuOptions={{ options: getOptions({ field: "projectName", isQuickFilterDisplay: Boolean(rowData.projectName) }), extraData: { fieldName: "projectName" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            download: true,
            print: true,
            field: "projectNo",
            headerName: t("general.projectNumber"),
            flex: 1,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.projectNo}
                        cellSubMenuOptions={{ options: getOptions({ field: "projectNo", isQuickFilterDisplay: Boolean(rowData.projectNo) }), extraData: { fieldName: "projectNo" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "objectsCount",
            type: 'number',
            headerName: t("general.objects"),
            flex: 1,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.objectsCount}
                        cellSubMenuOptions={{ options: getOptions({ field: "objectsCount", isQuickFilterDisplay: Boolean(rowData.objectsCount?.toString()) }), extraData: { fieldName: "objectsCount", type: "number" } }}
                        request={rowData}
                        isNumeric
                    />
                );
            },
        },
        {
            field: "projectType",
            headerName: t("general.type"),
            flex: 1,
            minWidth: 100,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.projectType}
                        cellSubMenuOptions={{ options: getOptions({ field: "projectType", isQuickFilterDisplay: Boolean(rowData.projectType) }), extraData: { fieldName: "projectType" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "place",
            headerName: t("general.address.city"),
            flex: 1,
            download: true,
            minWidth: 90,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.place}
                        cellSubMenuOptions={{ options: getOptions({ field: "place", isQuickFilterDisplay: Boolean(rowData.place) }), extraData: { fieldName: "place" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "projectConstructionType",
            headerName: t("general.project.constructionType"),
            flex: 1,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.projectConstructionType}
                        cellSubMenuOptions={{ options: getOptions({ field: "projectConstructionType", isQuickFilterDisplay: Boolean(rowData.projectConstructionType) }), extraData: { fieldName: "projectConstructionType" } }}
                        request={rowData}
                    />
                );
            },
        },
        {
            field: "projectPhase",
            headerName: t("general.phase"),
            flex: 1,
            minWidth: 90,
            download: true,
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    <LabelColumnV2
                        label={rowData.projectPhase}
                        cellSubMenuOptions={{ options: getOptions({ field: "projectPhase", isQuickFilterDisplay: Boolean(rowData.projectPhase) }), extraData: { fieldName: "projectPhase" } }}
                        request={rowData}
                    />
                );
            },
        }
    ];

}